import { Box, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'

import { SUPPLIER_ACTIVATION_CHART_HEIGHT } from 'components/reports/Metrics/constants/SupplierActivation'
import { SupplierActivationPointDto } from 'generated/graphql'

interface Props {
  points: SupplierActivationPointDto[]
}

export const SupplierActivationDataTable = ({ points }: Props) => (
  <Box sx={{ height: SUPPLIER_ACTIVATION_CHART_HEIGHT, overflow: 'auto' }}>
    <Table size='small' stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell>Days since creation</TableCell>
          <TableCell align='right'>% of drivers</TableCell>
          <TableCell align='right'>Drivers</TableCell>
          <TableCell align='right'>Eligible drivers</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {points.map((point) => (
          <TableRow key={point.day} hover>
            <TableCell>{point.day}</TableCell>
            <TableCell align='right'>{Math.round(point.percentage)}%</TableCell>
            <TableCell align='right'>{point.converted.toLocaleString()}</TableCell>
            <TableCell align='right'>{point.eligible.toLocaleString()}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
)
